import React from "react";
import { ColorScheme } from "../types/color.model";
import PaletteIcon from "../icons/PaletteIcon";
import Dropdown, { DropdownOption } from "./Dropdown";

interface ColorSchemeOption {
  value: ColorScheme;
  label: string;
  description?: string;
}

const colorSchemeOptions: ColorSchemeOption[] = [
  { value: "random", label: "Random", description: "Generate fresh random colors" },
  { value: "monochromatic", label: "Monochromatic", description: "Different shades of one color" },
  { value: "analogous", label: "Analogous", description: "Colors next to each other on color wheel" },
  { value: "complementary", label: "Complementary", description: "Colors opposite on color wheel" },
  { value: "split-complementary", label: "Split Complementary", description: "Base color + two adjacent to its complement" },
  { value: "triadic", label: "Triadic", description: "Three colors equally spaced on color wheel" },
  { value: "tetradic", label: "Tetradic", description: "Four colors forming rectangle on color wheel" },
  { value: "square", label: "Square", description: "Four colors equally spaced on color wheel" }
];

interface ColorSchemeDropdownProps {
  selectedScheme: ColorScheme | null;
  onSchemeSelect: (scheme: ColorScheme) => void;
  disabled?: boolean;
  className?: string;
}

const ColorSchemeDropdown: React.FC<ColorSchemeDropdownProps> = ({ selectedScheme, onSchemeSelect, disabled, className}) => {
  const selectedOption = colorSchemeOptions.find(option => option.value === selectedScheme);

  return (
    <Dropdown label="Color Scheme:" selectedLabel={selectedOption?.label || 'Select'} icon={<PaletteIcon />} disabled={disabled} className={className}>
      {({ close }) => colorSchemeOptions.map(({value, label, description}) => (
        <DropdownOption key={value} onClick={() => { onSchemeSelect(value); close(); }}>
          <div className="font-medium text-sm text-gray-900">{label}</div>
          {description && (
            <div className="text-xs text-gray-600 mt-1">{description}</div>
          )}
        </DropdownOption>
      ))}
    </Dropdown>
  )
};

export default ColorSchemeDropdown;
